export default __webpack_public_path__ + "static/media/finance-wallet.b6b11a02.svg";